import { NgModule } from '@angular/core';

import { LicenciamentosComponent } from './licenciamentos.component';
import { SharedModule } from "../../shared/shared.module";
import { LicenciamentoApiService } from "./shared/licenciamento-api.service";
import { LicenciamentoNavigationService } from "./shared/licenciamento-navigation.service";
import { LicenciamentosService } from "./shared/licenciamento.service";
import { LicenciamentosRoutingModule } from "./licenciamentos-routing.module";
import {LicenciamentoFormComponent} from "./licenciamento-form/licenciamento-form.component";
import {LicenciamentoListComponent} from "./licenciamento-list/licenciamento-list.component";

@NgModule({
    imports: [
        SharedModule,
        LicenciamentosRoutingModule
    ],
    providers: [
        LicenciamentoApiService,
        LicenciamentoNavigationService,
        LicenciamentosService,
    ],
    declarations: [
        LicenciamentosComponent,
        LicenciamentoFormComponent,
        LicenciamentoListComponent,
    ]
})
export class LicenciamentosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/licenciamentos/licenciamentos.module.ts
 **/